const doc = [({"da":({"js":({"admin":({"team_users":({"show":({"the_user_was_removed_from_the_team":"Brugeren blev fjernet fra holdet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;